import React, { useId } from "react";
import "../factorPills.css";
import "./factorChoice.css";

// docs/specs/sms-factor.md §1: the options, in this order. The authenticator is Recommended (NIST SP 800-63B-4
// §3.2.9: SMS is "restricted", so it is never the default and carries its risk line).
const OPTIONS = [
  { value: "totp", title: "Authenticator app", recommended: true,
    detail: "Codes from an app on your phone. Works without signal." },
  { value: "sms", title: "Text message",
    detail: "We text a code to your mobile. Less secure: a stolen number can receive your codes." },
];

// Two radio cards, one choice. Controlled: the caller holds `value` ("totp" | "sms"). Shared by the post-login nudge
// and, later, the after-SSN/TIN screen (A4) — docs/plans/sms-factor.md phases 3 and 9.
const FactorChoice = ({ value, onChange }) => {
  const id = useId();
  return (
    <fieldset className="mfa-factor-choice">
      <legend>How should we send your sign-in codes?</legend>
      {OPTIONS.map((o) => (
        <label key={o.value} htmlFor={`${id}-${o.value}`} className={`mfa-factor-card${value === o.value ? " is-selected" : ""}`}>
          <input type="radio" id={`${id}-${o.value}`} name={`${id}-factor`} value={o.value}
            checked={value === o.value} onChange={() => onChange(o.value)}
            aria-labelledby={`${id}-${o.value}-title`} aria-describedby={`${id}-${o.value}-detail`} />
          <span className="mfa-factor-text">
            <span id={`${id}-${o.value}-title`} className="mfa-factor-title">
              {o.title}
              {o.recommended && <span className="mfa-pill is-recommended">Recommended</span>}
            </span>
            <span id={`${id}-${o.value}-detail`} className="mfa-factor-detail">{o.detail}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
};

export default FactorChoice;
